import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { Box, Button, Illustration } from '@node-space/ui-components'
import { PathNames } from 'constants/General'
import { CustomerFeeSetupStep, CustomerFeeSetupSteps } from 'pages/Customers/types'

export interface CustomerFeeSuccessProps {
  setStep: (step: CustomerFeeSetupStep) => void
}

export const CustomerFeeSuccess = ({ setStep }: CustomerFeeSuccessProps) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const handleGoToCustomers = () => {
    navigate(PathNames.CUSTOMERS)
  }

  const handleBackToFeeSetup = () => {
    setStep(CustomerFeeSetupSteps.SELECT_CUSTOMER)
  }

  return (
    <Box
      flexCol
      align="center"
      justify="center"
      gapY={24}
      width="full"
      padding={32}
      className="text-center"
    >
      <Illustration name="HandsClapping" color="success" />
      <h1 className="text-h1 text-foreground-prominent">{t('customers.feeSetup.successTitle')}</h1>
      <p className="text-body-regular text-foreground-prominent max-w-md">
        {t('customers.feeSetup.successDescription')}
      </p>
      <Box flex gapX={12} className="mt-4">
        <Button variant="secondary" testId="go-to-customers" onClick={handleGoToCustomers}>
          {t('customers.feeSetup.goToMyCustomers')}
        </Button>
        <Button testId="back-to-fee-setup" onClick={handleBackToFeeSetup}>
          {t('customers.feeSetup.backToFeeSetup')}
        </Button>
      </Box>
    </Box>
  )
}
